import i18n from "lib/i18n";
import $ from "jquery";
import { template } from "lodash";
import LargeTooltipView from "views/large_tooltip_view";
/* eslint-disable
    func-names,
    no-multi-assign,
    no-shadow,
    no-undef,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentModeratorReasonView;

export default CommentModeratorReasonView = (function () {
  CommentModeratorReasonView = class CommentModeratorReasonView extends LargeTooltipView {
    static initClass() {
      this.prototype.className = "comment-moderator-reason-view large-tooltip arrow-left";

      this.prototype.events =
        { "submit form": "_handleSubmit" };

      this.prototype.template = template(`\
<h4 class="legacy">
  <%= i18n.t('comment_moderator.comment_removal') %>
</h4>

<%= i18n.t('comment_moderator.blurb_html') %>

<form action="#">
  <select name="reason">
  <% _.each(reasons, function(reason) { %>
    <option value="<%- reason %>"><%- reason %></option>
  <% }); %>
  </select>
  <button class="button right" type="submit"><%= i18n.t('comment_moderator.confirm_removal') %></button>
</form>\
`, { imports: { i18n } });

      this.prototype.alreadyApprovedTemplate = template(`\
<h4 class="legacy">
  <%= i18n.t('comment_moderator.comment_removal') %>
</h4>

<p><%= i18n.t('comment_moderator.approved') %></p>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);
      this.reasons = [
        i18n.t("comment_moderator.reasons.copyright_infringement"),
        i18n.t("comment_moderator.reasons.defamatory"),
        i18n.t("comment_moderator.reasons.discredited_research"),
        i18n.t("comment_moderator.reasons.discriminatory"),
        i18n.t("comment_moderator.reasons.fake_name"),
        i18n.t("comment_moderator.reasons.misinformation"),
        i18n.t("comment_moderator.reasons.off_topic"),
        i18n.t("comment_moderator.reasons.offensive"),
        i18n.t("comment_moderator.reasons.personal_abuse"),
        i18n.t("comment_moderator.reasons.spam"),
        i18n.t("comment_moderator.reasons.threatening"),
        i18n.t("comment_moderator.reasons.trolling"),
      ];
      this.link = options.link;
      this.comment = options.comment;
      this.removalReason = this.comment.get("removal_reason");
      this.removedAt = this.comment.get("removed_at");

      return this.render();
    }

    render() {
      const pos = this.link.position();

      if (!this.removedAt && this.removalReason) {
        this.$el.html(this.alreadyApprovedTemplate());
        this.$el.css("left", pos.left + 70);
        this.$el.css("top", pos.top - 51);
      } else {
        this.$el.html(this.template({ reasons: this.reasons }));
        this.$el.css("left", pos.left + 70);
        this.$el.css("top", pos.top - 88);
      }

      return this._listenToOutsideClick();
    }

    _handleSubmit(event) {
      event.preventDefault();
      this.trigger("reason:selected", $(event.target).serializeArray());
      return this.remove();
    }
  };
  CommentModeratorReasonView.initClass();
  return CommentModeratorReasonView;
}());
